import styled from "styled-components";
import { AllieColors } from "../../../common/color.types";

export const StatsItemStyled = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--allie-color-neutral-10);
  padding: 6px 8px;
  column-gap: 10px;
  color: var(--allie-color-neutral-60);
  border-radius: 8px;
  width: fit-content;
`;

export const StatsVariation = styled.div<{ color?: AllieColors }>`
  display: flex;
  align-items: center;
  column-gap: 2px;
  color: var(--allie-color-${props => props.color || 'neutral-50'});
  background-color: white;
  padding: 4px;
`;
